import RailsResource from './rails-resource';

class EnrollmentContractService extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'enrollments/contract',
      ajaxLoader: true
    });
  }

  cancel(contractId, reasonCancellationId, reasonCancellation, tuitionCancelIds, attendancesEndDate, studentAccessStrategy) {
    return this.post(`${this.url}/${this.resource}/${contractId}/cancel.json`, true, {
      tuition_cancel_ids: tuitionCancelIds,
      enrollment_contract: {
        cancellation_reason_id: reasonCancellationId,
        canceled_reason: reasonCancellation,
        attendances_end_date: attendancesEndDate,
        student_access_strategy: studentAccessStrategy
      }
    });
  }

  finish(contractId, body) {
    return this.post(`${this.url}/${this.resource}/${contractId}/finish.json`, true, body);
  }

  debits(contractId) {
    return this.get(`${this.url}/${this.resource}/${contractId}/debits`, false);
  }

  destroy(id, htmlResponse = true) {
    return this.delete(`${this.route}/${id}${htmlResponse ? '' : '.json'}`, !htmlResponse);
  }
}

export default new EnrollmentContractService();